export default "__VITE_ASSET__4Y3yQDb6__"